import { ReactElement } from 'react'
import { Box } from '@mui/material'
import { FormFields } from '@editor/components/SingleElementCSForm/components/FormFields'
import ManagerSection from '../ManagerSection'

export type DefaultMember = Extract<ElementTypes, 'purlins' | 'beams' | 'columns'>

interface Props {
  member: DefaultMember
  title: string
  readOnly: boolean
}

const DefaultMemberCrossSectionForm = ({ member, title, readOnly }: Props): ReactElement => {
  return (
    <ManagerSection title={title}>
      <Box data-cy={`default-cross-section-${member}`}>
        <FormFields elementType={member} isDisabled={readOnly} name={member} />
      </Box>
    </ManagerSection>
  )
}

export default DefaultMemberCrossSectionForm
